import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { MainParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { MainReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { MainReportGridData } from '@pages/reporting-pages/deliveries-main/types/MainReportGridData';
import { convertToGridData } from '@pages/reporting-pages/deliveries-main/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingDeliveriesMainState {
	gridData: MainReportGridData[] | null,
	dateRange: DateRange | null,
};

const initialState: ReportingDeliveriesMainState = {
	gridData: null,
	dateRange: null,
};



export const reportingDeliveriesMainSlice = createSlice({
	name: 'reportingDeliveriesMain',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<MainReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<MainParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSearchParameters,
	resetStore } = reportingDeliveriesMainSlice.actions;